import * as classnames from 'classnames'
import get from 'lodash-es/get'
import head from 'lodash-es/head'
import * as React from 'react'

import { IImageUrl, IMatch } from '../../../../typings/searchResults'

import * as styles from './imagePreview.module.css'

const landscapePreviewUrl = (item: IMatch) => {
  const urls =
    get(item, 'previews.landscape_preview.image_urls') ||
    get(item, 'previews.icon_with_video_preview.image_urls') ||
    []

  return get(head(urls), 'url')
}

const getImgixImg = (item: IMatch): any =>
  landscapePreviewUrl(item) || getMarketingImg(item)

const getMarketingImg = (item: IMatch): any =>
  get(item, 'previews.landscape_preview.landscape_url') ||
  get(item, 'previews.icon_with_video_preview.landscape_url')

const ImagePreview = ({ item }: { item: IMatch }) => {
  const imageClass = classnames(
    styles.preview,
    'preload no_preview landscape-image-magnifier'
  )

  let fallbackUsed = false

  return (
    <img
      alt={item.name}
      className={imageClass}
      src={getImgixImg(item)}
      title={item.name}
      onError={(e: any): void => {
        if (!fallbackUsed) {
          fallbackUsed = true
          e.target.src = getMarketingImg(item)
        }
      }}
    />
  )
}

export default ImagePreview
